import axios, { InternalAxiosRequestConfig } from "axios";


export const API_URL = `${window.location.origin.toString()}/api/v1/`;

const api = axios.create({
    baseURL: API_URL
});


const tg = window.Telegram.WebApp;

api.interceptors.request.use(async function (config: InternalAxiosRequestConfig) {
    if (tg.initData)
        config.headers.Authorization = `Bearer ${tg.initData}`;
    return config;
});

export default api;